<template>
  <div>
    <v-btn
      height="31px"
      color="primary"
      outlined
      @click="logar()"
      x-small
      min-width="10px"
      max-width="35px"
      width="32px"
      style="border: 2px solid"
    >
      <v-icon color="primary" small>mdi-lock</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { enviar } from "../../mixins/RequisicaoMixin.js";
import { headersLogin } from "../../mixins/HeadersMixin.js";
import crypto from "../../crypto";

export default {
  methods: {
    logar() {
      this.$emit("gerenciarCarregamentoLoginEmailSenha", true);
      const cabecalho = headersLogin();
      enviar("/api/v1/auth", cabecalho, this.usuario)
        .then((s) => {
          let novoUsuarioLogado = {
            email: this.usuario.email,
            token: s.token,
            logadoGoogle: false,
            papel: s.papel,
            cliente: s.cliente,
            exibeTutorialDeNavegacao: s.exibeTutorialDeNavegacao,
            idDoUsuario: s.idDoUsuario,
            ss: crypto.criptografar(this.usuario.senha),
          };
          localStorage.setItem(
            "usuarioLogado",
            JSON.stringify(novoUsuarioLogado)
          );
          this.$emit("redirecionarUsuario", novoUsuarioLogado);
        })
        .catch(() => {
          this.$store.commit("erro", "E-mail ou senha incorreto.");
        })
        .finally(() =>
          this.$emit("gerenciarCarregamentoLoginEmailSenha", false)
        );
    },
  },
  props: {
    usuario: {
      type: Object,
      default: () => {
        return {
          email: "",
          senha: "",
        };
      },
    },
    carregandoLoginGoogle: {
      type: Boolean,
      default: false,
    },
    pressionouEnter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    pressionouEnter(enterPressionado) {
      if (enterPressionado) this.logar();
    },
  },
};
</script>

<style>
</style>